const GaTrackingIds: {
  [key: string]: string[];
} = {};

const FacebookPixelIds: {
  [key: string]: string;
} = {};

const TwitterPixelIds: {
  [key: string]: string;
} = {};

const TiktokPixelIds: {
  [key: string]: string;
} = {};

const TradeDeskIds: {
  [key: string]: string[]; // By convention, first element is the advertiserId, the rest is segment id
} = {};

GaTrackingIds["brewers"] = ["DC-2946534"];
GaTrackingIds["frontwavearena"] = ["AW-11394969496"];
GaTrackingIds["gamecocks"] = ["G-VZH9W38TYJ"];
GaTrackingIds["la-kings"] = ["AW-16733286784", "DC-14879299"];
GaTrackingIds["reign"] = ["AW-328056858"];
GaTrackingIds["windsurge"] = ["AW-978300184"];

FacebookPixelIds["brewers"] = "2892474421069407";
FacebookPixelIds["frontwavearena"] = "1041852372858187";
FacebookPixelIds["gamecocks"] = "799264502421457";
FacebookPixelIds["la-kings"] = "1201822627599125";
FacebookPixelIds["reign"] = "171994126573408";
FacebookPixelIds["remix"] = "548254070716126";
FacebookPixelIds["fresnogrizzlies"] = "1736516757278123";
FacebookPixelIds["66ers"] = "542601775586004";
FacebookPixelIds["greenjackets"] = "3596561407316694";
FacebookPixelIds["barons"] = "1959251398225406";

TwitterPixelIds["gamecocks"] = "nxkro";

TiktokPixelIds["la-kings"] = "CUSDOQBC77UCOV2DUTKG";

TradeDeskIds["fresnogrizzlies"] = ["aszns79", "e187lw7"];
TradeDeskIds["66ers"] = ["dp1o1s6", "cahoj3d"];

export function getTrackingIdsBySubdomain(subdomain: string) {
  if (!GaTrackingIds[subdomain]) {
    return [];
  }
  return GaTrackingIds[subdomain];
}

export function getFacebookPixelIdBySubdomain(subdomain: string) {
  if (!FacebookPixelIds[subdomain]) {
    return "";
  }
  return FacebookPixelIds[subdomain];
}

export function getTwitterPixelIdBySubdomain(subdomain: string) {
  if (!TwitterPixelIds[subdomain]) {
    return "";
  }
  return TwitterPixelIds[subdomain];
}

export function getTiktokPixelIdBySubdomain(subdomain: string) {
  if (!TiktokPixelIds[subdomain]) {
    return "";
  }
  return TiktokPixelIds[subdomain];
}

export function getTradeDeskIdBySubdomain(subdomain: string) {
  if (!TradeDeskIds[subdomain]) {
    return [];
  }
  return TradeDeskIds[subdomain];
}
